import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=f8b1ee9c"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports